<template>
  <div class="preloader">
    <h2>{{preloaderTitle}}</h2>
    <div class="meaning">

    </div>

    <div class="block what">
      <h3></h3>
      <p>

      </p>
    </div>

    <div class="block where">
      <h3></h3>
      <p>

      </p>
    </div>

    <div class="block similar">
      <h3></h3>
      <p>

      </p>
    </div>

    <div class="block relatedWrapper">
      <h3></h3>
      <p>

      </p>
    </div>
  </div>
</template>

<script>
    export default {
        name: 'Preloader',
        props: ['preloaderTitle'],

        data: function () {
            return {

            }
        },
        methods: {

        }
    };
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Preloader.vue